import { Tooltip, TooltipProps } from '@material-tailwind/react';
import { forwardRef } from 'react';
import Info from '$/components/icons/Info';

const InfoIcon = forwardRef<HTMLDivElement>((_, ref) => {
  return (
    <span ref={ref} className="ml-1 inline-flex items-center">
      {/* eslint-disable-next-line tailwindcss/no-arbitrary-value */}
      <Info className="inline-block size-[18px] align-middle text-secondary-lighter md:size-[22px]" />
    </span>
  );
});

InfoIcon.displayName = 'InfoIcon';

export default function FormFieldLabel({
  id,
  label,
  optional,
  optionalLabel,
  tooltip,
  placement,
  onTooltipHover,
}: {
  id?: string;
  label?: string;
  optional?: boolean;
  optionalLabel?: string;
  tooltip?: string;
  placement?: TooltipProps['placement'];
  onTooltipHover?: () => void;
}): JSX.Element | null {
  if (!label) {
    return null;
  }

  return (
    <label
      htmlFor={id}
      className="mhg-alpha-typography-caption inline-flex items-center text-highlights/gray-dark"
    >
      {label}
      {optional && ` (${optionalLabel})`}
      {tooltip && (
        <Tooltip
          content={
            // eslint-disable-next-line tailwindcss/no-arbitrary-value
            <div className="max-w-[242px] md:max-w-65 lg:max-w-[286px] xl:max-w-[322px]">
              {tooltip}
            </div>
          }
          placement={placement}
        >
          <span
            className="ml-1 inline-flex items-center"
            onMouseEnter={onTooltipHover}
          >
            <Info className="inline-block size-shapes/icon-size-md align-middle text-text/disabled" />
          </span>
        </Tooltip>
      )}
    </label>
  );
}
